<div class="container-fluid">
    <div id="home-banner-container-1" class="home-banner-container">
        <ngb-carousel
            class="custom-carousel"
            *ngIf="banners?.['banner1']?.['images']?.length"
            [activeId]="'slide-banner1-' + banners['banner1'].activeIndex"
            [showNavigationArrows]="false"
            [showNavigationIndicators]="false"
            [interval]="7000"
            (slide)="onBannerSlide($event, 'banner1')"
        >
            <ng-template
                ngbSlide
                *ngFor="let image of banners['banner1'].images; let idx = index"
                [id]="'slide-banner1-' + idx"
            >
                <img
                    [src]="isMobile ? image.mobile : image.desktop"
                    class="h-t-banner"
                    (click)="handleBannerClick('banner1', idx)"
                    alt="Banner 1 image"
                />
            </ng-template>
        </ngb-carousel>
    </div>
    <div class="h-category-carousel h-block">
        <div
            *ngIf="
                !trendingEntries ||
                (trendingEntries && trendingEntries.length > 0)
            "
            class="h-category-title"
        >
            <h2>{{ "Trending" | translate }}</h2>
        </div>
        <ng-container *ngIf="trendingEntries">
            <div mdDesktopOnly>
                <div class="h-trending-desktop-container h-presenter">
                    <div
                        *ngFor="let dealEntry of trendingEntries"
                        class="h-trending-desktop-item"
                    >
                        <md-product-card
                            [dealEntry]="dealEntry"
                            (dealSelected)="dealSelected($event)"
                            [noBanners]="true"
                        ></md-product-card>
                    </div>
                </div>
            </div>
            <div mdMobileOnly class="h-category-carousel" id="swiper-trending">
                <swiper [config]="swiperConfigTrending" class="custom-swiper">
                    <div class="swiper-wrapper h-swiper-container">
                        <div
                            class="swiper-slide"
                            *ngFor="let dealEntry of trendingEntries"
                        >
                            <md-product-card
                                [dealEntry]="dealEntry"
                                (dealSelected)="dealSelected($event)"
                                [noBanners]="true"
                            ></md-product-card>
                        </div>
                    </div>
                </swiper>
            </div>
        </ng-container>
        <ng-container *ngIf="!trendingEntries">
            <div mdDesktopOnly>
                <div class="h-trending-desktop-container h-presenter">
                    <div
                        *ngFor="
                            let dealEntry of trendingEntriesLoadingPlaceholder
                        "
                        class="h-trending-desktop-item"
                    >
                        <md-product-card-loading />
                    </div>
                </div>
            </div>

            <div mdMobileOnly class="h-category-carousel">
                <swiper [config]="swiperConfigTrending" class="custom-swiper">
                    <div class="swiper-wrapper h-swiper-container">
                        <div
                            class="swiper-slide"
                            *ngFor="let dealEntry of [0, 1, 2]"
                        >
                            <md-product-card-loading />
                        </div>
                    </div>
                </swiper>
                <div
                    mdMobileOnly
                    class="swiper-button-next swiper-trending-button-next"
                ></div>
                <div
                    mdMobileOnly
                    class="swiper-button-prev swiper-trending-button-prev"
                ></div>
            </div>
        </ng-container>
    </div>
    <div *ngIf="bestSellerCategories">
        <div
            class="h-category-carousel h-block"
            *ngFor="
                let bestSellerCategory of bestSellerCategories.categories;
                let i = index
            "
        >
            <ng-container *ngIf="bestSellerCategory.data.length > 0">
                <div class="h-category-title">
                    <h2>
                        {{ bestSellerCategory.category | translate }}
                    </h2>
                </div>
                <div *ngIf="i === 0 || i === 1" mdDesktopOnly>
                    <div class="h-trending-desktop-container h-presenter">
                        <div
                            *ngFor="let dealEntry of bestSellerCategory.data"
                            class="h-trending-desktop-item"
                        >
                            <md-product-card
                                [dealEntry]="dealEntry"
                                (dealSelected)="dealSelected($event)"
                                [noBanners]="true"
                            ></md-product-card>
                        </div>
                    </div>
                </div>
                <ng-container *ngIf="i === 0 || i === 1">
                    <div mdMobileOnly [attr.id]="'swiper-best-sellers-' + i">
                        <swiper
                            [config]="getSwiperConfig(i)"
                            class="custom-swiper"
                        >
                            <div
                                class="swiper-wrapper h-swiper-container h-block"
                            >
                                <div
                                    class="swiper-slide"
                                    *ngFor="
                                        let dealEntry of bestSellerCategory.data
                                    "
                                >
                                    <md-product-card
                                        [dealEntry]="dealEntry"
                                        (dealSelected)="dealSelected($event)"
                                        [noBanners]="true"
                                    ></md-product-card>
                                </div>
                            </div>
                        </swiper>
                    </div>
                </ng-container>
                <ng-container *ngIf="i >= 2">
                    <div [attr.id]="'swiper-best-sellers-' + i">
                        <swiper
                            [config]="getSwiperConfig(i)"
                            class="custom-swiper"
                        >
                            <div
                                class="swiper-wrapper h-swiper-container h-block"
                            >
                                <div
                                    class="swiper-slide"
                                    *ngFor="
                                        let dealEntry of bestSellerCategory.data
                                    "
                                >
                                    <md-product-card
                                        [dealEntry]="dealEntry"
                                        (dealSelected)="dealSelected($event)"
                                        [noBanners]="true"
                                    ></md-product-card>
                                </div>
                            </div>
                        </swiper>
                        <div
                            mdDesktopOnly
                            class="swiper-button-next swiper-best-sellers-button-next-{{
                                i
                            }}"
                        ></div>
                        <div
                            mdDesktopOnly
                            class="swiper-button-prev swiper-best-sellers-button-prev-{{
                                i
                            }}"
                        ></div>
                    </div>
                </ng-container>
            </ng-container>
            <div *ngIf="i === 1" class="home-banner-container">
                <ngb-carousel
                    class="custom-carousel"
                    *ngIf="banners?.['banner2']?.['images']?.length"
                    [activeId]="
                        'slide-banner2-' + banners['banner2'].activeIndex
                    "
                    [showNavigationArrows]="false"
                    [showNavigationIndicators]="false"
                    [interval]="7000"
                    (slide)="onBannerSlide($event, 'banner2')"
                >
                    <ng-template
                        ngbSlide
                        *ngFor="
                            let image of banners['banner2'].images;
                            let idx = index
                        "
                        [id]="'slide-banner2-' + idx"
                    >
                        <img
                            [src]="isMobile ? image.mobile : image.desktop"
                            class="h-t-banner"
                            (click)="handleBannerClick('banner2', idx)"
                            alt="Banner 2 image"
                        />
                    </ng-template>
                </ngb-carousel>
            </div>
        </div>
    </div>
    <div
        *ngIf="!bestSellerCategories"
        class="h-category-carousel h-block"
        style="margin-bottom: 100px"
    >
        <div class="h-category-title">
            <h2>
                {{ "Hotels" | translate }}
            </h2>
        </div>
        <swiper [config]="swiperConfig" class="custom-swiper">
            <div class="swiper-wrapper h-swiper-container">
                <div
                    class="swiper-slide"
                    *ngFor="let dealEntry of getRepeatArray(5)"
                >
                    <md-product-card-loading />
                </div>
            </div>
            <div class="swiper-button-next"></div>
            <div class="swiper-button-prev"></div>
        </swiper>
    </div>
</div>
